export default __webpack_public_path__ + "0c6a95a523343723322e7125a0c99f16.jpg";